module.exports = __webpack_public_path__ + "static/media/study 201030.5759c64e.png";